<template>
    <div class='my-imgup'>
        <img class="img" :src="src" v-if="src != ''" @click="onClick">
        <div class="noimg" v-else><Icon class="noimg-icon" type="ios-image" size="40"/></div>
    </div>
</template>

<script>
    export default {
        props:{
            src: {
                default: "",
                type: String,
            }
        },
        computed:{
//            src_new:function () {
//                return this.src == ''?'':this.src+'?t='+new Date().getTime();
//            }
        },
        methods:{
            onClick:function () {
                this.$emit("onClick");
            }
        }
    }
</script>

<style scoped>
    .my-imgup .img{
        width: 100%;
        cursor: pointer;
        display: inherit;
        border-radius: 5px;
    }
    .my-imgup .noimg{
        width: 100%;
    }
    .my-imgup .noimg-icon{
        color: #d3d3d3;
    }
</style>



// WEBPACK FOOTER //
// src/components/myImgshow.vue